import { Link } from 'react-router-dom';
import { comics, popularComicIds } from '@/mocks/comics';

const popularComics = popularComicIds.map((id) => comics.find((c) => c.id === id)!);

export default function PopularSection() {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <section id="popular" className="py-12 md:py-16">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              人气排行
            </h2>
            <p className="text-foreground-500 text-sm">读者最爱的漫画作品</p>
          </div>
          <a href="#" className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap">
            查看完整榜单 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {popularComics.slice(0, 10).map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                {index < 3 ? (
                  <span className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold ${
                    index === 0
                      ? 'bg-accent-500 text-background-50'
                      : index === 1
                      ? 'bg-secondary-500 text-background-50'
                      : 'bg-secondary-300 text-background-50'
                  }`}>
                    {index + 1}
                  </span>
                ) : (
                  <span className="text-foreground-400 font-bold text-sm">{index + 1}</span>
                )}
              </div>

              <div className="w-14 h-20 flex-shrink-0 rounded-md overflow-hidden bg-background-200">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
                <div className="flex items-center gap-2 mt-1.5">
                  <span className="flex items-center gap-0.5 text-xs text-accent-600">
                    <i className="ri-star-fill text-xs"></i> {comic.rating}
                  </span>
                  <span className="text-xs text-foreground-400">{formatViews(comic.views)} 阅读</span>
                  <span className={`px-1.5 py-0.5 rounded text-xs ${
                    comic.status === '连载中'
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {comic.status}
                  </span>
                </div>
              </div>

              <div className="flex-shrink-0 text-foreground-300">
                <i className="ri-arrow-right-s-line text-xl"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}